/**
 * «این متن فرستاده نمی‌شود» + اعتراض (WHOSUP-309) — قرینه‌ی `showFilterBlocked`
 * در `apps/mobile/src/ui/errors.ts`.
 *
 * `window.confirm` مثلِ بقیه‌ی تاییدهای سایت (حذفِ دوست، حذفِ گروه): «باشه»
 * یعنی اعتراض بفرست، «لغو» یعنی برمی‌گردم و متن را عوض می‌کنم.
 *
 * `true` برمی‌گرداند اگر خطا مالِ فیلتر بود و رسیدگی شد — صدازننده دیگر
 * نباید آن را به `reportError` بدهد: کاربر کارِ اشتباهی نکرده که در
 * client_errors بنشیند.
 */
import { t } from '@/core/lib/i18n';
import { reportError } from '@/core/lib/report';
import { isObjectionableError } from '@/core/lib/contentFilter';
import { appealContentFilter } from '@/core/data/reportRepo';

export function handleFilterBlocked(e: unknown): boolean {
  if (!isObjectionableError(e)) return false;
  const msg = `${t('filterBlockedTitle')}\n\n${t('filterBlockedBody', { words: e.matched.join(', ') })}\n\n${t('filterAppeal')}?`;
  if (window.confirm(msg)) {
    appealContentFilter(e)
      .then(() => window.alert(t('filterAppealSent')))
      .catch((err) => { reportError('web.filter.appeal', err); window.alert(t('errorRetry')); });
  }
  return true;
}
